module.exports = __webpack_public_path__ + "media/images/categories/r-splash-meta-tag2-bc35da1ad1dced865e566de8b980c39c.png";